import { render, staticRenderFns } from "./WorkPlaceList.vue?vue&type=template&id=7fab6033&scoped=true"
import script from "./WorkPlaceList.vue?vue&type=script&lang=js"
export * from "./WorkPlaceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fab6033",
  null
  
)

export default component.exports